"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VARY_HEADER = exports.CACHE_CONTROL_HEADER = exports.PUBLIC_PAGE_SIZE = exports.QS_STRINGIFY_OPTIONS = void 0;
exports.QS_STRINGIFY_OPTIONS = { arrayFormat: 'comma', skipNulls: true };
exports.PUBLIC_PAGE_SIZE = 24; // 24
var DAY = 60 * 60 * 24;
exports.CACHE_CONTROL_HEADER = "public, max-age=".concat(60 * 10);
exports.VARY_HEADER = 'origin, accept-encoding';
//# sourceMappingURL=other.js.map